<template>
    <v-dialog v-model="value" max-width="800">
        <v-card>
            <v-card-title class="d-flex justify-space-between">
                <slot name="title"></slot>
                <v-btn icon @click="close"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
                <slot></slot>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
    props: ['value'],
    watch: {
        value() {
            this.$emit('input', this.value)
        },
    },
    methods: {
        close() {
            this.value = false
        },
    },
}
</script>
